import { render, staticRenderFns } from "./CestaBasica.vue?vue&type=template&id=cd4aad46"
import script from "./CestaBasica.vue?vue&type=script&lang=js"
export * from "./CestaBasica.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports